import { environment } from '@environments/environment';

export const resolveAssetPath = (dir: string, name: string) => {
  return [environment.host, 'assets', dir, name].join('/');
};

export const resolveAssetImage = (path: string) => {
  return resolveAssetPath('images', path);
};

export const resolveAssetIcon = (name: string) => {
  return resolveAssetPath('icons', name);
};

export const resolveAssetFixture = (name: string) => {
  return resolveAssetPath('fixtures', name);
};
